import { render, staticRenderFns } from "./ViewDistination.vue?vue&type=template&id=70822943&scoped=true"
import script from "./ViewDistination.vue?vue&type=script&lang=js"
export * from "./ViewDistination.vue?vue&type=script&lang=js"
import style0 from "./ViewDistination.vue?vue&type=style&index=0&id=70822943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70822943",
  null
  
)

export default component.exports